export default "__VITE_ASSET__C90570QF__"